var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"email-draft"},[(_vm.email.inactive)?_c('p',{staticClass:"alert alert-info text-center fixed-bottom",staticStyle:{"margin-bottom":"0"}},[_vm._v("\n    This is a draft email!\n    "),(!_vm.hidePublish)?_c('button',{staticClass:"btn btn-sm btn-warning ml-1",on:{"click":_vm.publish}},[_vm._v("\n      Publish\n    ")]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-657b5947","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailDraft.vue
// module id = 1212
// module chunks = 1